<div [ngClass]="{'blur': biometricCheck && isSecuredPath}">
<router-outlet></router-outlet>
</div>
<app-alert-view></app-alert-view>
